import styled, {css} from "styled-components";
import {Button} from "../../../../../basic-ui-components/button/base/button.component";

export const ExploreButtonBox = styled(Button)`
  ${props => css`
    background: linear-gradient(${props.theme.colors.brandPrimaryContrast}, ${props.theme.colors.brandPrimaryContrast}) padding-box,
    linear-gradient(to bottom, ${props.theme.colors.brandSecondary}, ${props.theme.colors.brandPrimary}) border-box;
    border-radius: 18px;
    border: 2px solid transparent;
    color: ${props.theme.colors.textContrast};
  `}
`;
